import { deleteReports, setReports } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

const useReports = () => {
  const reportsState = useSelector((state: any) => state.reports);
  const [storedReports, setStoredReports] = useState<any>(reportsState);
  const dispatch = useDispatch();

  useEffect(() => {
    setStoredReports(reportsState);
  }, [reportsState]);

  const storeReports = (_reports: any) => {
    dispatch(setReports(_reports));
  };

  const removeReports = () => {
    dispatch(deleteReports());
  };

  return { reports: storedReports, removeReports, storeReports };
};

export default useReports;
